import type { LicenseStatus } from '@/types/models';

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/**
 * `expired` lorsque la date du jour est strictement postérieure au jour d'expiration.
 * Le jour d'expiration lui-même reste `active`. Sans date, la licence est `active`.
 */
export function licenseStatus(expires: Date | null | undefined, now: Date = new Date()): LicenseStatus {
  if (!expires || Number.isNaN(expires.getTime())) return 'active';
  return startOfDay(now) > startOfDay(expires) ? 'expired' : 'active';
}
